export default __webpack_public_path__ + "static/media/SHARE.aacbdb18.png";